import {
  AcademicCapIcon,
  BarsIcon,
  FolderIcon,
  PaperPlaneIcon
} from './assets/icons'

export const features = [
  {
    name: 'Tech College',
    description:
      ' Devsnest School Community helps us choose the right tech college and help you connect with a number of Alumni',
    icon: AcademicCapIcon
  },
  {
    name: 'Mentorship',
    description:
      'Guidance on tech stack,  projects to build and support from Industry professionals and senior developers  ',
    icon: FolderIcon
  },
  {
    name: 'Networking Opportunities',
    description:
      ' Connect with peers and industry leaders through online events, meetups, and forums to build your professional network and explore career opportunities.',
    icon: BarsIcon
  },

  {
    name: 'Skill Bootcamps',
    description:
      'Learn tech via our beginner-friendly Bootcamps to help you kickstart your tech career',
    icon: PaperPlaneIcon
  }
]
